import * as types from '../../actionTypes';

const initialState = {
    medicineActivateInfo: [],
    error: {},
    loading: false
}


export const medicineActivateReducer = (state = initialState, action) => {
    switch (action.type) {
        case types.MEDICINE_ACTIVATE_LOADING:
            return {
                ...state,
                loading: true
            }
        case types.MEDICINE_ACTIVATE_SUCCESS:
            console.log("action.payload",action.payload)
            return {
                ...state,
                medicineActivateInfo: action.payload,
                loading: false,
                error: {}
            }
        case types.MEDICINE_ACTIVATE_FAIL:
            return{
                ...state,
                error: action.payload,
                loading: false,
            } 


        default:
            return state;
    }
}